<template>
  <ListView
    :items="videos"
    :with-sites="false"
    color="primary"
    title-field="title|url"
    description-field="description|kind"
    :create-item="'video_albums_create'"
    :edit-item="'video_albums_edit'"
    :site="$attrs.site_key"
    :label="$attrs.site_title"
    :items-name="'media/videos'"
    @remove-item="updateData"
  >
    <template v-slot:info="{ item }">
      <v-btn icon tag="span" @click.stop="function () {}">
        <v-icon :color="item.published ? 'green' : 'grey'">mdi-check</v-icon>
      </v-btn>
    </template>
  </ListView>
</template>

<script>
import ListView from '@/components/ListView'
import api from '@/mixins/api'
import utils from '@/mixins/utils'
import list_view from '@/mixins/list_view'

export default {
  name: 'Albums',
  components: { ListView },
  mixins: [api, utils, list_view],
  data() {
    return {
      videos: [],
    }
  },
  watch: {
    '$attrs.site_key'() {
      this.updateData()
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    cover(album) {
      return album.cover.url || require('@/assets/images/img_404.png')
    },
    updateData() {
      this.albums = []
      this.axios({
        url: '/v1/media/videos',
        method: 'get',
        params: { site_key: this.$attrs.site_key },
      })
        .then((resp) => {
          this.videos = resp.data || []
          this.$log.debug('get video data', this.videos)
        })
        .catch((err) => {
          this.$log.error('get video data', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>

<style scoped lang="scss">
.album {
  cursor: pointer;
  height: 300px;
  width: 200px;
}
</style>
